import { render, staticRenderFns } from "./PointsHistory.vue?vue&type=template&id=3ccd6cdc&scoped=true"
import script from "./PointsHistory.vue?vue&type=script&lang=js"
export * from "./PointsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccd6cdc",
  null
  
)

export default component.exports